import moment from "moment"
import useFlightStore from "../../../store/flightStore"
import { useQuery } from "@tanstack/react-query"
import { getBlockFlightDetails } from "../../../api/flightsAPI"
import { useAuthStore } from "../../../store/authStore"
import { useEffect, useState } from "react"

const BlockFlightTimeInfoModal = ({ id }) => {
    const { token } = useAuthStore((state) => state)
    const { data: blockTimeDetailData } = useQuery(["getBlockFlightTimeDetail", token, id], () => getBlockFlightDetails(token, id))
    const { setShowBlockFlightTimeModal } = useFlightStore((state) => state)
    const [blockTimeData, setBlockTimeData] = useState({})

    useEffect(() => {
        if (blockTimeDetailData?.data?.data) {
            setBlockTimeData(blockTimeDetailData?.data?.data)
        }
    }, [blockTimeDetailData])

    return (
        <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
            <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                <div className="relative max-w-xl">
                    <div className="relative bg-white rounded-lg dark:bg-white" onBlur={() => { setShowBlockFlightTimeModal(false) }}>
                        <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">

                            <span>
                                <h3 className="text-3xl font-semibold text-gray-900 dark:text-black capitalize">
                                    Restricted Flight Time
                                </h3>
                            </span>
                            <button onClick={() => { setShowBlockFlightTimeModal(false) }} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="p-5 grid grid-cols-2 pb-0">
                            <div className="pr-4">
                                <span>
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Starts From</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{moment(blockTimeData?.startTime).format("DD/MM/YYYY HH:mm")}</h3>
                                    </div>
                                </span>
                            </div>
                            <div className="pr-4">
                                <span>
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Ends On</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{moment(blockTimeData?.endTime).format("DD/MM/YYYY HH:mm")}</h3>
                                    </div>
                                </span>
                            </div>
                            <div className="pr-4">
                                <span>
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Position</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{blockTimeData?.lat},{blockTimeData?.lng}</h3>
                                    </div>
                                </span>
                            </div>
                            <div className="pr-4">
                                <span>
                                    <div>
                                        <h3 className="text-sm text-tblu font-semibold">Radius</h3>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold capitalize">{`${blockTimeData?.radius}m`}</h3>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="p-5">
                            <span>
                                <div>
                                    <h3 className="text-sm text-tblu font-semibold">Reason For Blocking</h3>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold capitalize break-all">{blockTimeData?.reason}</h3>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlockFlightTimeInfoModal;